<div class="lg">
  <aside class="lg-marca">
    <img class="lg-logo" [src]="isDarkMode ? brandService.logoTelaNegativo : brandService.logoTela" [alt]="brandService.nomeMarcaTela">

    <div class="lg-chamada">
      <span class="lg-produto">Flua · Pré-Atendimento</span>
      <h2>Atendimento<br>que flui.</h2>
      <p>Senhas, guichês e consultórios conectados num só lugar.</p>
    </div>

    <p class="lg-endosso">
      <span>{{ brandService.nomeMarcaTela }}</span> faz parte do ecossistema
      <img [src]="isDarkMode ? 'marca/flua-negativo.png' : 'marca/flua-positivo.png'" alt="Flua">
    </p>
  </aside>

  <section class="lg-lado-form" [ngClass]="isLoading ? 'login-ocupado' : ''">
    <div class="lg-arco" aria-hidden="true"></div>
    <div class="lg-cartao">
      <div class="login-cabecalho">
        <h1>Entrar</h1>
        <p>Use o mesmo usuário e senha do Tasy.</p>
      </div>

      <form class="login-campos" method="post" [formGroup]="loginForm" (ngSubmit)="submit()" #formDir="ngForm" novalidate>
        <div class="login-campo">
          <label for="user">Usuário</label>
          <div class="login-input" [class.login-input-erro]="!!erroCredencial || (user.invalid && formDir.submitted)">
            <input #campoUsuario id="user" name="user" formControlName="user" type="text" autocomplete="username"
                   placeholder="INFORME O USUÁRIO" spellcheck="false" autocapitalize="characters" (input)="erroCredencial = ''" />
          </div>
          <span *ngIf="user.invalid && formDir.submitted" class="login-msg-erro">Informe o usuário.</span>
        </div>

        <div class="login-campo">
          <label for="password">Senha</label>
          <div class="login-input" [class.login-input-erro]="!!erroCredencial || (password.invalid && formDir.submitted)">
            <input #campoSenha id="password" name="password" formControlName="password" [type]="passwordFieldType"
                   autocomplete="current-password" placeholder="Digite a senha"
                   (keydown)="onTeclaSenha($event)" (keyup)="onTeclaSenha($event)" (blur)="capsLock = false" (input)="erroCredencial = ''" />
            <button type="button" class="login-mostrar" (click)="togglePasswordVisibility()"
                    [attr.aria-pressed]="passwordFieldType === 'text'">
              {{ passwordFieldType === 'password' ? 'Mostrar' : 'Ocultar' }}
            </button>
          </div>
          <span *ngIf="capsLock" class="login-msg-aviso" aria-live="polite"><i></i>Caps Lock está ativo</span>
          <span *ngIf="password.invalid && formDir.submitted && !erroCredencial" class="login-msg-erro">Informe a senha.</span>
          <span *ngIf="erroCredencial" class="login-msg-erro" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
            </svg>
            {{ erroCredencial }}
          </span>
        </div>

        <button type="submit" class="login-botao" [disabled]="isLoading">
          <span *ngIf="isLoading" class="login-spinner" aria-hidden="true"></span>
          {{ isLoading ? 'Entrando…' : 'Entrar' }}
        </button>
      </form>
    </div>
  </section>

  <footer class="lg-versao">
    <span *ngIf="versao">v{{ versao }}</span>
    <span>{{ ambiente }}</span>
    <span *ngIf="suporte">Suporte {{ suporte }}</span>
  </footer>
</div>


<app-modal-form *ngIf="selectUnitModal">
  <div class="lu-modal">
    <button type="button" class="lu-voltar" (click)="closeSelectUnitModal()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
      Voltar
    </button>

    <div class="lu-icone" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
      </svg>
    </div>
    <h2 class="lu-titulo">Onde você vai atender hoje?</h2>
    <p class="lu-sub">Entrando como <b>{{ user.value | uppercase }}</b>. Escolha a unidade e o guichê.</p>

    <form class="lu-campos" (submit)="$event.preventDefault()">
      <div class="login-campo">
        <label>Unidade</label>
        <app-lista-selecao [itens]="itensUnidades" [valor]="selectedUnit" [desabilitado]="units.length == 0" [comBusca]="true" [ultimaUsada]="ultimaUnidade"
                           placeholder="Selecione a sua unidade" rotuloAcessivel="Unidade" (escolher)="selectUnit($event)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
          </svg>
        </app-lista-selecao>
        <span *ngIf="!hasUnits" class="login-msg-erro">Nenhuma unidade foi encontrada para este usuário.</span>
      </div>

      <div class="login-campo">
        <label>Guichê</label>
        <app-lista-selecao [itens]="itensGuiches" [valor]="selectedWindow" [desabilitado]="!selectedUnit || !hasTicketWindow" [ultimaUsada]="ultimoGuiche"
                           placeholder="Selecione o seu guichê" rotuloAcessivel="Guichê" (escolher)="selectTicketWindow($event)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25" />
          </svg>
        </app-lista-selecao>
        <span *ngIf="!hasTicketWindow" class="login-msg-erro">Nenhum guichê cadastrado para esta unidade.</span>
        <span *ngIf="hasTicketWindow && !selectedUnit" class="lu-dica">Escolha a unidade para ver os guichês.</span>
      </div>

      <button type="button" class="login-botao" (click)="goToDashboard()" [disabled]="isSelectButtonDisabled">
        Confirmar
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" style="width: 18px; height: 18px">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
      </button>
    </form>
  </div>
</app-modal-form>

<!-- Perfil -->
<app-modal-form *ngIf="isProfileModalOpen">
  <div class="lu-modal">
    <button type="button" class="lu-voltar" (click)="closeModal('profile')">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
      Voltar
    </button>

    <div class="lu-icone" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
      </svg>
    </div>
    <h2 class="lu-titulo">Com qual perfil você vai entrar?</h2>
    <p class="lu-sub">Escolha como vai usar a Fila nesta sessão.</p>

    <div class="lp-perfis" role="radiogroup" aria-label="Perfil">
      <button *ngFor="let profile of profiles" type="button" class="lp-perfil" role="radio"
              [class.lp-ativo]="selectedProfile === profile.id" [attr.aria-checked]="selectedProfile === profile.id"
              (click)="selectProfile(profile.id)" (dblclick)="setProfileSelect(profile.id)">
        <span class="lp-radio" aria-hidden="true"></span>
        <span class="lp-texto">
          <b>{{ profile.name }}</b>
          <small>{{ descricaoPerfil(profile.id) }}</small>
        </span>
      </button>
    </div>

    <button type="button" class="login-botao lp-confirmar" (click)="setProfileSelect(selectedProfile)" [disabled]="!isProfileSelected">
      Entrar como {{ perfilEscolhido || '...' }}
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" style="width: 18px; height: 18px">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
      </svg>
    </button>
  </div>
</app-modal-form>

<!-- Error Modal  -->
<app-modal *ngIf="openModal" (onClick)="closeModal('erro')" [title]="'Ops...'" class="dark:bg-zinc-900">
    <div selector="body" class="mt-4 px-6">
        {{errorMessage}}
    </div>
    <div selector="footer" class="flex justify-end mt-4 px-4 py-4">
        <button (click)="closeModal('erro')" class="bg-red-400 dark:bg-red-600 text-white px-4 py-2 rounded">Fechar</button>
    </div>
</app-modal>